import { TextField, Typography } from "@mui/material";
import React from "react";

const LabelInput = ({ label, value, onChange, type, required, disabled }) => {
  return (
    <div>
      <Typography variant="body1">{label}</Typography>
      <TextField
        required={required}
        type={type}
        fullWidth
        value={value}
        onChange={onChange}
        disabled={disabled}
        size="small"
        variant="outlined"
      />
    </div>
  );
};

export default LabelInput;
